import { useEffect, useState } from 'react';
import files, { FileDownloaded } from '~src/controllers/FilesController';

export default function useDownload(url?: string) {
	const [file, setFile] = useState<FileDownloaded>({ url });
	useEffect(() => {
		files.download(url).then(file => setFile(file));
	}, [url]);
	return file;
}